import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const ChevronDown: React.FC<IProps> = (props) => {
	return (
		<svg
			width="20"
			height="21"
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10 14.4995C9.41668 14.4995 8.83335 14.2745 8.39168 13.8329L2.95835 8.39954C2.71668 8.15788 2.71668 7.75788 2.95835 7.51621C3.20002 7.27454 3.60002 7.27454 3.84168 7.51621L9.27502 12.9495C9.67502 13.3495 10.325 13.3495 10.725 12.9495L16.1583 7.51621C16.4 7.27454 16.8 7.27454 17.0417 7.51621C17.2833 7.75788 17.2833 8.15788 17.0417 8.39954L11.6084 13.8329C11.1667 14.2745 10.5833 14.4995 10 14.4995Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(ChevronDown);
